{
  "attempts": "Intentos",
  "camera_open": "Cámara abierta",
  "clear": "Borrar registro",
  "empty": "Todavía no hay nada. Captura algo con la cámara y vuelve.",
  "exif_gps": "GPS en EXIF",
  "exif_orientation": "Orientación EXIF",
  "file_age": "Antigüedad del archivo",
  "had_link": "Tenía un enlace",
  "had_photo": "Con foto",
  "had_text": "Palabras escritas",
  "heading": "Registro de capturas",
  "intro": "Cada captura y cada arranque de la app en este dispositivo, lo más reciente primero. Solo en lab, para el experimento de captura y el arranque de la app.",
  "kind_camera_cancelled": "Cámara cancelada",
  "kind_capture": "Capturado",
  "kind_capture_failed": "La captura falló",
  "kind_capture_queued": "Guardado en el teléfono, pendiente de enviar",
  "kind_location_late": "Ubicación agregada después de guardar",
  "kind_outbox_dropped": "Rechazado tras esperar",
  "kind_outbox_sent": "Enviado desde la bandeja de salida",
  "kind_paste": "Pegado",
  "kind_reloaded": "La app se recargó con la cámara abierta",
  "kind_start": "La app arrancó",
  "kind_unreadable": "No se pudo leer la foto",
  "link": "Registro de capturas (lab)",
  "location": "Ubicación",
  "location_accuracy": "Precisión",
  "location_after_save": "Llegó después de guardar",
  "location_first_fix": "Primera lectura",
  "location_fixes": "Lecturas",
  "location_sent": "Guardada con la cosa",
  "metres": "{value} m",
  "ms": "{value} ms",
  "no": "no",
  "none": "ninguna",
  "not_here": "El registro de capturas solo existe en lab.",
  "open_to_save": "Hoja abierta → guardado",
  "original": "De la cámara",
  "page_title": "Registro de capturas — TingThings",
  "paste_attached": "Se volvió la foto",
  "paste_files": "Archivos",
  "paste_types": "Tipos en el portapapeles",
  "phone_online": "El teléfono decía en línea",
  "photo_upload_failed": "La foto no se subió",
  "prepare": "Reducirla tomó",
  "seconds": "{value} s",
  "start_browser": "Navegador",
  "start_first_paint": "Primer dibujo",
  "start_home": "Inicio en pantalla",
  "start_native": "App de iOS",
  "start_photos": "Fotos ({count})",
  "start_platform": "Plataforma conocida",
  "start_ready": "Cubierta retirada",
  "start_running": "App web en marcha",
  "start_session": "Sesión confirmada",
  "start_where": "Dónde",
  "upload": "Subida",
  "uploaded_as": "Subida como",
  "waited": "Esperó",
  "yes": "sí"
}
